import { Link } from 'react-router-dom';
import { Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { Page, Button } from '@occc-app/design-system';

import { ChatHistoryTable } from './chat-history-table.component';
import { useChatHistory } from './hooks/use-chat-history.hook';

import { routeCreator } from '../../drive-insights.router';

const PAGE_TITLE = 'Chat History';

export const ChatHistoryPage = () => {
  const { conversations, loading, error, paginationProps } = useChatHistory();

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
      }}
      actions={
        <Button
          color='primary'
          variant='contained'
          component={Link}
          to={routeCreator.base()}
          startIcon={<AddIcon />}
        >
          New Conversation
        </Button>
      }
      containerProps={{
        sx: {
          pb: 3,
          // Override the design-system header title color for the Insights light background
          '& .MuiTypography-h4': { color: 'drive.textPrimary' },
        },
      }}
    >
      <Box
        sx={{
          width: '100%',
          bgcolor: 'white',
          border: 1,
          borderColor: 'drive.border',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        <ChatHistoryTable
          conversations={conversations}
          loading={loading}
          error={error}
          paginationProps={paginationProps}
        />
      </Box>
    </Page>
  );
};
